import Constants from '@intercom/embercom-composer/lib/constants';
export default function (html) {
  return html.replace(/\s?data\-id=\\?"(block|entity)\-ember\d+\\?"/g, '').replace(/\s?data\-generated-at=\\?"[0-9\.]+\\?"/g, '').replace(Constants.COPY_SAFE_HREF_REGEX, '');
}